import { Component, OnDestroy, OnInit } from '@angular/core';

import { UiSidebarService } from '@ib-core/services/ui-sidebar.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'ib-auth-header',
  templateUrl: './auth-header.component.html',
  styleUrls: ['./auth-header.component.scss'],
})
export class AuthHeaderComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public isSidebarFullSize: boolean;

  constructor(private sidebarS: UiSidebarService) {
    super();
  }

  ngOnInit(): void {
    this.sidebarS
      .selectIsSidebarExpanded()
      .pipe(takeUntil(this.destroy$))
      .subscribe(r => (this.isSidebarFullSize = r?.v));
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
  }

  closedStart(): void {
    this.sidebarS.setSidebarState(false);
  }

  toggleSidebar(): void {
    this.sidebarS.toggleSidebar();
  }

  openedStart(): void {
    this.sidebarS.setSidebarState(true);
  }
}
